/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-05-29 11:22:40
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-10-16 21:28:31
 */
export default (Vue) => {
  return [
    {
      title: "优惠券名称",
      key: "name",
      minWidth: 230,
      align: 'center'
    },
    {
      title: "优惠金额",
      key: "reduce",
      minWidth: 180,
      align: 'center'
    },
    {
      title: "满减条件",
      key: "full",
      align: 'center',
      minWidth: 80
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 200,
      render: (h, { row }) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: {
              color: "#3091FF"
            },
            on: {
              click: () => {
                row.validDate = [row.startDt, row.endDt];
                Vue.formData = row;
                Vue.detailFlag = true;
                Vue.showNewDialog = true;
              }
            }
          }, '详情'),
          h('Button', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: {
              color: "#3091FF"
            },
            on: {
              click: () => {
                row.validDate = [row.startDt, row.endDt];
                Vue.formData = row;
                Vue.editFlag = true;
                Vue.detailFlag = false;
                Vue.showNewDialog = true;
              }
            }
          }, '编辑'),
          h('Button', {
            props: {
              type: 'text',
              size: 'small',
            },
            style: {
              color: "#3091FF"
            },
            on: {
              click: () => {
                Vue.$Modal.confirm({
                  title: `确定要删除${row.name}么`,
                  loading: true,
                  onOk: async () => {
                    Vue.$post("/coupon/delete", { couponIds: row.couponId }).then((da) => {
                      Vue.getCouponList();
                      Vue.$Modal.remove();
                      Vue.$Notice.success({ title: `${row.name}删除成功` });
                    });
                  }
                });
              }
            }
          }, '删除'),
        ]);
      }
    }
  ]
}